import * as React from 'react'
import './template-blank.css'

export const BlankTemplate = ({className, colors, ...props}: any)  =>
<svg id="Component_blank_1" className="blank-template" xmlns="http://www.w3.org/2000/svg"
width="60" height="85.4" viewBox="0 0 600 854">
  <rect id="Rectangle_116" data-name="Rectangle 116" className="blank-template-1" width="600" height="854"/>
  
  <rect id="Rectangle_83" data-name="Rectangle 83" style={{fill: colors.primary_color}} width="600" height="200"/>
  
  <rect id="Rectangle_2000" data-name="Rectangle 2000" style={{fill: colors.primary_color}}
  width="600" height="23" transform="translate(0 831)"/>
  
  <line id="Line_4" data-name="Line 4" className="blank-template-2" x2="591.955" transform="translate(1.537 184.153)"/>
  
  <line id="Line_5" data-name="Line 5" className="blank-template-3" x2="591.955" transform="translate(1.537 41.965)"/>
  
  <rect id="Rectangle_1998" data-name="Rectangle 1998" className="blank-template-5" width="80" height="6" rx="3" transform="translate(24 19)"/>
  <rect id="Rectangle_1999" data-name="Rectangle 1999" className="blank-template-5" width="80" height="6" rx="3" transform="translate(495 19)"/>
  
  <rect id="Rectangle_blank_content" data-name="Rectangle Blank Content" className="blank-template-4" width="504" height="408" rx="8" transform="translate(48 223)"/>
  
  <rect id="Rectangle_placeholder" data-name="Rectangle Placeholder" className="blank-template-1" width="169" height="87" transform="translate(219 66)"/>
</svg>